import actors from './actors'
import typesOfSale from './types-of-sale'
import frequencies from './frequencies'
import pages from './pages'
import paymentsStates from './payments-states'
import persons from './persons'
import periods from './periods'
import salesStates from './sales-states'
import subscriptionStates from './subscriptions-states'
import invoiceStates from './invoice-states'
import typesOfProduct from './types-of-product'

const parameters = {
  actors: [...actors],
  typesOfProduct: [...typesOfProduct],
  typesOfSale: [...typesOfSale],
  frequencies: [...frequencies],
  invoiceStates: [...invoiceStates],
  pages: [...pages],
  paymentsStates: [...paymentsStates],
  periods: [...periods],
  persons: [...persons],
  salesStates: [...salesStates],
  subscriptionStates: [...subscriptionStates]
}

export default parameters
